// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"791":"fe6622b0","2411":"4104ac08","2473":"75ca9c4c","3785":"fe6622b0","5516":"6f43b12d","8524":"ee133278"}[chunkId] + ".chunk.css";
};